export interface RawCapacity {
  id: number | null;
  weekly_capacity: number;
  daily_capacity: number;
  work_days: string | null; // 'MON,TUE,WED,THU,FRI'
  total_working_days: number | null;
  weekly_working_days: number | null;
  current: boolean;
  start_date: string;
  end_date: string | null;
}

export interface RawCapacityPayload {
  user_id: number;
  capacities: Array<RawCapacity>;
}

export const DurationSummaryKeys = [
  'duration',
  'billable_duration',
  'non_billable_duration',
  'total_duration',
  'capacity',
  'total_capacity',
  'planned_duration',
  'tasked_duration',
] as const;

export interface DurationSummary extends Record<(typeof DurationSummaryKeys)[number], number> {}

export const SUMMARY_API_LIMIT = 50;
